import React, { useContext, useEffect } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { PageDataContext } from "../../utils/common/PageDataContext";

const Dashboard = () => {
  const { setPageData } = useContext(PageDataContext);
  useEffect(() => {
    setPageData({
      title: "Dashboard",
      // icon: <HomeIcon />,
      showBackButton: false,
      customActions: <button>Refresh</button>,
      breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);
  // useEffect(() => {
  //   setPageTitle("Dashboard");
  // }, [setPageTitle]);
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6">Total Page Views</Typography>
            <Typography variant="h4">4,42,236</Typography>
            <Typography variant="body2" color="textSecondary">
              You made an extra 35,000 this year
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6">Total Users</Typography>
            <Typography variant="h4">78,250</Typography>
            <Typography variant="body2" color="textSecondary">
              You made an extra 8,900 this year
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6">Total Order</Typography>
            <Typography variant="h4">18,800</Typography>
            <Typography variant="body2" color="textSecondary">
              You made an extra 1,943 this year
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6">Total Sales</Typography>
            <Typography variant="h4">$35,078</Typography>
            <Typography variant="body2" color="textSecondary">
              You made an extra $20,395 this year
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
